import { KeyValue } from '@/main/models/common';
import { IntegrationTypes, IntegrationActionTypes } from './index';
import { IntegrationQueueServiceRequest } from '@/main/models/request';
import { IntegrationInterfaceResponse } from '@/main/models/response';
import { IntegrationInterfaceFilter } from '@/main/models/request/integrationRequest';

export function getDomain(): IntegrationActionTypes {
  return {
    type: IntegrationTypes.GET_DOMAIN
  };
}

export function saveDomain(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): IntegrationActionTypes {
  return {
    type: IntegrationTypes.SAVE_DOMAIN,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerDomain(): IntegrationActionTypes {
  return {
    type: IntegrationTypes.RESET_REDUCER_DOMAIN
  };
}

export function getService(idIntegrationType: number): IntegrationActionTypes {
  return {
    type: IntegrationTypes.GET_SERVICE,
    payload: idIntegrationType
  };
}

export function saveService(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): IntegrationActionTypes {
  return {
    type: IntegrationTypes.SAVE_SERVICE,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerService(): IntegrationActionTypes {
  return {
    type: IntegrationTypes.RESET_REDUCER_SERVICE
  };
}

export function getDomainIntegrationIntegrationInterfaces(
  request: IntegrationQueueServiceRequest
): IntegrationActionTypes {
  return {
    type: IntegrationTypes.GET_DOMAIN_INTEGRATION_INTEGRATION_INTERFACES,
    payload: request
  };
}

export function saveDomainIntegrationIntegrationInterfaces(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): IntegrationActionTypes {
  return {
    type: IntegrationTypes.SAVE_DOMAIN_INTEGRATION_INTEGRATION_INTERFACES,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerDomainIntegrationIntegrationInterfaces(): IntegrationActionTypes {
  return {
    type:
      IntegrationTypes.RESET_REDUCER_DOMAIN_INTEGRATION_INTEGRATION_INTERFACES
  };
}

export function getIntegrationIntegrationInterface(
  guidIntegrationInterface: string | null = null
): IntegrationActionTypes {
  return {
    type: IntegrationTypes.GET_INTEGRATION_INTEGRATION_INTERFACE,
    payload: {
      guidIntegrationInterface
    }
  };
}

export function saveIntegrationIntegrationInterface(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): IntegrationActionTypes {
  return {
    type: IntegrationTypes.SAVE_INTEGRATION_INTEGRATION_INTERFACE,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerIntegrationIntegrationInterface(): IntegrationActionTypes {
  return {
    type: IntegrationTypes.RESET_REDUCER_INTEGRATION_INTEGRATION_INTERFACE
  };
}

export function getIntegrationInterface(
  integrationInterfaceFilter: IntegrationInterfaceFilter
): IntegrationActionTypes {
  return {
    type: IntegrationTypes.GET_INTEGRATION_INTERFACE,
    payload: {
      integrationInterfaceFilter
    }
  };
}

export function saveIntegrationInterface(
  data: IntegrationInterfaceResponse[] | null,
  isError: boolean,
  errorMessages: string[] | null
): IntegrationActionTypes {
  return {
    type: IntegrationTypes.SAVE_INTEGRATION_INTERFACE,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerIntegrationInterface(): IntegrationActionTypes {
  return {
    type: IntegrationTypes.RESET_REDUCER_INTEGRATION_INTERFACE
  };
}
